var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"period-filter"},_vm._l((_vm.periods),function(opt){return _c('button',{key:opt.value,class:['period-btn', { active: _vm.selected === opt.value }],attrs:{"type":"button"},on:{"click":function($event){return _vm.select(opt.value)}}},[_vm._v(" "+_vm._s(opt.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }